import useAuth from "@/useAuth";
import { computed } from '@vue/composition-api'


export default function useNewsImage() {

    const { tenant } = useAuth();

    const getPrimaryImage = (news) => {
        if (Object.keys(news).length) {
            if (Object.keys(news.image).length) {
                return news.image;
            }
        }
        if (tenant.value.news_image != null) {
            return tenant.value.news_image;
        }
        return tenant.value.logo;
    }

    return {
        getPrimaryImage
    }
}